import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { VariantFilterValue } from "../models/product";

@Component
export default class ImageVariantFilter extends Vue {
    protected showImagePicker: boolean = false;
    protected selectedFilter: VariantFilterValue = { imageResourceUrl: "", value: "", variantId: ""};

    @Prop()
    protected filterValues!: VariantFilterValue[];

    @Prop()
    protected selectedFilterValue!: string;

    @Watch("filterValues")
    protected onFilterValuesChange() {
        if (this.filterValues && this.filterValues.length) {
            this.selectedFilter = this.filterValues[0];
        }
    }

    @Watch("selectedFilterValue")
    protected onSelectedFilterValueChange() {
        this.selectedFilter = this.filterValues.find(x => x.value === this.selectedFilterValue) || this.filterValues[0];
    }

    protected mounted() {
        if (this.filterValues && this.filterValues.length) {
            this.selectedFilter = this.filterValues.find(x => x.value === this.selectedFilterValue) || this.filterValues[0];
        }
    }

    protected onFilterChange() {
        this.toggleImagePicker();
        this.$emit("update:selectedFilterValue", this.selectedFilter.value);
    }

    protected toggleImagePicker() {
        this.showImagePicker = !this.showImagePicker;
    }
}
